import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import My from '../views/My.vue'
import map from '../views/Map.vue'
import water from '../views/water.vue'
import Mycoupon from '../views/Mycoupon.vue'
import MyAttention from '../views/MyAttention.vue'
import MyQuestion from '../views/MyQuestion.vue'
import MyQuestionDetail from '../views/MyQuestionDetail.vue'
import searchShop from '../views/searchShop.vue'
import toUse from '../views/toUse.vue'
import shopIndex from '../views/shopIndex.vue'
import ShopCertification from '../views/ShopCertification.vue'
import WxAuth from '../views/WxAuth.vue'
import mapLocation from '../views/mapLocation.vue'
import Feedback from '../views/Feedback.vue'
import giveTo from '../views/giveTo.vue'
import ActiveCoupon from '../views/ActiveCoupon.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'WxAuth',
    component: WxAuth
  },
  {
    path: '/home',
    name: 'home',
    component: Home,
  },
  {
    path: '/map',
    name: 'map',
    component: map
  },
  {
    path: '/water',
    name: 'water',
    component: water
  },
  {
    path: '/My',
    name: 'My',
    component: My
  },
  {
    path: '/Mycoupon',
    name: 'Mycoupon',
    component: Mycoupon
  },
  {
    path: '/MyAttention',
    name: 'MyAttention',
    component: MyAttention
  },
  {
    path: '/MyQuestion',
    name: 'MyQuestion',
    component: MyQuestion
  },
  {
    path: '/MyQuestionDetail',
    name: 'MyQuestionDetail',
    component: MyQuestionDetail
  },
  {
    path: '/searchShop',
    name: 'searchShop',
    component: searchShop
  },
  {
    path: '/toUse',
    name: 'toUse',
    component: toUse
  },
  {
    path: '/shopIndex',
    name: 'shopIndex',
    component: shopIndex
  },
  {
    path: '/ShopCertification',
    name: 'ShopCertification',
    component: ShopCertification
  },
  {
    path: '/mapLocation',
    name: 'mapLocation',
    component: mapLocation
  },
  {
    path: '/Feedback',
    name: 'Feedback',
    component: Feedback
  },
  {
    path: '/giveTo',
    name: 'giveTo',
    component: giveTo
  },
  {
    path: '/ActiveCoupon',
    name: 'ActiveCoupon',
    component: ActiveCoupon
  },
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

export default router
